import React from "react";
import Circle from "~/components/Icons/icon-circle";
import CheckMark from "~/components/Icons/icon-check-mark";
import { ROLE_TYPES } from "~/constans/roles";

interface AnsweredCellProps {
  comment?:
    | {
        User?: {
          role?: string;
        };
      }
    | string
    | null;
  myRole?: string;
}

export const AnsweredCell: React.FC<AnsweredCellProps> = ({
  comment,
  myRole,
}) => {
  const isDealer = ROLE_TYPES.DEALER.name;
  const isHolding = ROLE_TYPES.HOLDING.name;
  const iAmADealer = myRole === isDealer || myRole === isHolding;

  if (!comment || comment === "-" || typeof comment === "string") {
    return (
      <div>
        <Circle width={"16px"} height={"16px"} fill={"#89959c"} />
      </div>
    );
  }

  const commentRole = comment?.User?.role;
  const isDealerComment =
    commentRole && (commentRole === isDealer || commentRole === isHolding);

  if (iAmADealer && isDealerComment) {
    return (
      <div>
        <Circle width={"16px"} height={"16px"} fill={"#89959c"} />
      </div>
    );
  }

  if (!iAmADealer && !isDealerComment) {
    return (
      <div>
        <Circle width={"16px"} height={"16px"} fill={"#89959c"} />
      </div>
    );
  }

  return (
    <div>
      <CheckMark width={"16px"} height={"16px"} fill={"#ec8c22"} />
    </div>
  );
};
